export const runAfterInteractions = (task?: () => any) => {
  if (task) {
    task();
  }
};
